// (c) 2023 ABBYY Development, Inc.

import { Dispatch, FC, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from 'components';
import { FlexContainer } from './CommonStyled';
import { Container } from './ApplicationListStyled';
import EditableList from './EditableList';
export interface ApplicationListItems {
    isEnabled: boolean;
    items: any[];
}

export type ApplicationListItemSetter = Dispatch<
    SetStateAction<ApplicationListItems>
>;

export interface ApplicationListProps {
    isReadOnly: boolean;
    whitelist: ApplicationListItems;
    whitelistSetter: ApplicationListItemSetter;
    blacklist: ApplicationListItems;
    blacklistSetter: ApplicationListItemSetter;
}

const ApplicationList: FC<ApplicationListProps> = ({
    whitelist,
    blacklist,
    whitelistSetter,
    blacklistSetter,
    isReadOnly
}) => {
    const { t } = useTranslation();

    return (
        <Container>
            <Box my={4}>
                <Typography variant="body2">
                    {t(
                        'views.applications.recording_service.application_list.description'
                    )}
                </Typography>
            </Box>
            <FlexContainer>
                <EditableList
                    isTemplateReadOnly={isReadOnly}
                    applicationList={blacklist as ApplicationListItems}
                    itemSetter={blacklistSetter}
                    title={t('expressions.blacklist')}
                    hint={
                        <>
                            <Typography>
                                {t(
                                    'views.applications.recording_service.application_list.dialog.hint'
                                )}
                            </Typography>
                            <Typography>
                                {t(
                                    'views.applications.recording_service.application_list.dialog.example',
                                    {
                                        example: '*\\notepad++.exe'
                                    }
                                )}
                            </Typography>
                        </>
                    }
                />
                <EditableList
                    isTemplateReadOnly={isReadOnly}
                    applicationList={whitelist as ApplicationListItems}
                    itemSetter={whitelistSetter}
                    title={t('expressions.whitelist')}
                    hint={
                        <>
                            <Typography>
                                {t(
                                    'views.applications.recording_service.application_list.dialog.hint'
                                )}
                            </Typography>
                            <Typography>
                                {t(
                                    'views.applications.recording_service.application_list.dialog.example',
                                    {
                                        example: '*\\notepad++.exe'
                                    }
                                )}
                            </Typography>
                        </>
                    }
                />
            </FlexContainer>
        </Container>
    );
};

export default ApplicationList;
